import { gridBreakPoints } from 'common/theme'
import styled from 'styled-components'

export const StyledStepperContainer = styled.div<{ step4ButtonClicked?: boolean }>`
  flex: 1;
  transform: translateY(1.3rem);

  .StepperContainer-0-2-1 {
    padding: 0;
    width: 100%;

    @media (min-width: ${gridBreakPoints.md}) {
      width: 76%;
    }
    @media (min-width: ${gridBreakPoints.lg}) {
      width: 70%;
    }
  }

  #RFS-Connector {
    border-top-width: 7px;
    transform: translateY(-3px);
  }

  /* #RFS-StepContainer:last-child #RFS-ConnectorContainer span {
    border-color: ${({ theme }) => theme.colors.inputBorder} !important;
  } */

  button > span {
    display: none;
  }

  #RFS-StepButton.active ~ #RFS-LabelContainer {
    #RFS-Label {
      color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    }
  }
  #RFS-StepButton.completed ~ #RFS-LabelContainer {
    #RFS-Label {
      color: ${({ theme }) => theme.colors.stepperCompleteColor};
    }
  }

  #RFS-LabelContainer > span {
    font-family: ${({ theme }) => theme.fonts.fontBase}, 'Verdana', 'sans-serif', -apple-system;
    font-weight: 700;
    font-size: 11px;
  }

  #RFS-StepButton.completed:disabled:hover {
    background-color: ${({ theme }) => theme.colors.stepperCompleteColor};
  }
`
